import spinner from '../../images/spinner-ripple.svg';

/**
 * Unified loading indicator for data widgets and visualizations. Same ripple
 * the inner data layers (e.g. MatrixData) already use, centered in whatever
 * box the caller gives it — replaces the scattered "Laden..." /
 * "Template data laden..." text states.
 *
 * @param {object} props
 * @param {string} [props.className] - Extra class(es) on the wrapper, e.g. `loading-spinner--inline` for a small inline spinner
 */
const LoadingSpinner = ({ className = '' }) => (
    <div className={`loading-spinner ${className}`.trim()} role="status" aria-label="Laden">
        <img src={spinner} alt="" />
    </div>
);

export default LoadingSpinner;
